import { Box, Button, Typography, styled } from '@mui/material'
import * as React from 'react'
import { colors } from '../../constants/colors'
import { HBox } from '../../elements/basic-elements'

type ConfirmationProps = {
  title?: string
  description?: string
  confirmText?: string
  denyText?: string
  onDeny?: React.MouseEventHandler<HTMLButtonElement>
  onConfirm: React.MouseEventHandler<HTMLButtonElement>
  disableConfirm?: boolean
}

const ConfirmationPrompt: React.FC<React.PropsWithChildren<ConfirmationProps>> = ({
  title,
  description,
  confirmText,
  denyText,
  onDeny,
  onConfirm,
  disableConfirm,
  children
}) => {
  return (
    <>
      <CardContent>
        {title && (
          <Typography variant="h4" color={colors.WHITE} pt={2}>
            {title}
          </Typography>
        )}
        {description && <Typography variant="body2">{description}</Typography>}
        {children}
        <HBox gap={2} width="100%" pt={2}>
          {onDeny && (
            <Button
              fullWidth
              variant="contained"
              disableElevation
              sx={{ py: 2 }}
              color="secondary"
              onClick={onDeny}
            >
              <Typography variant="h5" fontWeight={400} color={colors.WHITE}>
                {denyText || 'No'}
              </Typography>
            </Button>
          )}
          <Button
            fullWidth
            variant="contained"
            disableElevation
            sx={{ py: 2 }}
            color="primary"
            onClick={onConfirm}
            disabled={disableConfirm}
          >
            <Typography variant="h5" fontWeight={400} color={colors.WHITE}>
              {confirmText || 'Yes'}
            </Typography>
          </Button>
        </HBox>
      </CardContent>
    </>
  )
}

const CardContent = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
  text-align: center;
`
export default ConfirmationPrompt
